import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#062b89',
        secondary: '#a6eeea',
        ternary: '#999999',
        succcess: '#1d9612',
        error: '#c21717',
      },
    },
  },
});
